// 우편
export const POST_LIST_REQUEST = 'POST_LIST_REQUEST';

export const SET_POST_LIST = 'SET_POST_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_POST_PAGINATION = 'SET_POST_PAGINATION';

export const POST_DETAILS_REQUEST = 'POST_DETAILS_REQUEST';

export const SET_POST_DETAILS = 'SET_POST_DETAILS';

export const POST_EXCEL_DOWNLOAD = 'POST_EXCEL_DOWNLOAD';

export const POST_ITEM_SEARCH_REQUEST = 'POST_ITEM_SEARCH_REQUEST';

export const SET_POST_ITEM_LIST = 'SET_POST_ITEM_LIST';

export const POST_USER_SEARCH_REQUEST = 'POST_USER_SEARCH_REQUEST';

export const SET_POST_USER_LIST = 'SET_POST_USER_LIST';

export const POST_CREATE_REQUEST = 'POST_CREATE_REQUEST';

export const POST_DEPOSIT_REQUEST = 'POST_DEPOSIT_REQUEST';

export const POST_RESPONSE_MESSAGE = 'POST_RESPONSE_MESSAGE';

export const POST_REMOVE_REQUEST = 'POST_REMOVE_REQUEST';
